
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import { getProject, getProjectKatuzeItems, getProjectStatus } from '../../reducers/project';
import { getKatuzeItems } from '../../reducers/katuze';
import OverviewPanelKatuze from './OverviewPanelKatuze';
import OverviewPanelModules from './OverviewPanelModules';
import ProjectCommandBar from './ProjectCommandBar';
import IfComp from '../common/IfComp';

const classNames = mergeStyleSets({
    projectOverview: {
        paddingLeft: 16
    },
    projectContentContainer: {
        overflowY: 'auto',
        height: 700,
        paddingRight: 16
    },
    title: {
        paddingRight: 32
    },
    loginInfo: {
        paddingRight: 14
    }
});

const ProjectOverviewContent = ({loaded, katuzeItems, projectId, projectKatuzeItems, projectStatus}) => {

    const canDisplayOpsub = (
        (katuzeItems.length > 0) &&
        (projectKatuzeItems.length > 0) &&
        (projectStatus === 'SELECT_OPSUB')
    );

    return (
        <Stack tokens={{childrenGap: 8}}>
            <Stack horizontal tokens={{childrenGap: 8}}>
                <OverviewPanelKatuze />
                <IfComp cond={canDisplayOpsub}>
                    <OverviewPanelModules
                        projectId={projectId}
                        loaded={loaded}
                    />
                </IfComp>
            </Stack>
        </Stack>
    );
}

const ProjectOverview = (props) => {

    const project = useSelector(state => getProject(state.project));
    const projectStatus = useSelector(state => getProjectStatus(state.project));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));
    const katuzeItems = useSelector(state => getKatuzeItems(state.katuze));

    return (
        <Stack verticalFill className={classNames.projectOverview}>
            <Stack.Item>
                <Stack horizontal verticalAlign="baseline">
                    <Stack.Item grow className={classNames.title}>
                        <Text mega>{props.project.data.project.title}</Text>
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <ProjectCommandBar project={props.project} />
            </Stack.Item>
            <Stack.Item grow className={classNames.projectContentContainer}>
                <ProjectOverviewContent
                    katuzeItems={katuzeItems}
                    projectKatuzeItems={projectKatuzeItems}
                    projectStatus={projectStatus}
                    projectId={project.id}
                    loaded={props.loaded}
                />
            </Stack.Item>
        </Stack>
    );
}

export default ProjectOverview;
